// extracted by mini-css-extract-plugin
export default {"banner":"KycBanner_banner__DhL4m","link":"KycBanner_link__aHku7"};